module.exports = __webpack_public_path__ + "static/media/processing-unscreen.444b44c0.gif";